import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function resetExperience(): RootActionTypes {
  return standardAction(ActionTypes.RESET_EXPERIENCE);
}
